import { ImageTagDetail } from '@spencer/apis/ecrPublicClient';

const NameCellWithoutLink = (item: ImageTagDetail) => item.imageTag;

export default NameCellWithoutLink;
